import React from 'react'
import camelCase from 'camelcase'
import MaterialTextField from '@material-ui/core/TextField'

type OnChangeFunction = (string) => void;
type TextAreaProps = {
  id: number,
  initialValue: string,
  label: string,
  isRequired: boolean,
  onChange: OnChangeFunction,
};

const TextArea: React.FunctionComponent<TextAreaProps> = ({ id, initialValue, label, isRequired, onChange }: TextAreaProps) => {
  const key = camelCase(label)

  const setCurrentValueHandler = (event) => {
    const newValue = event.target.value
    onChange(newValue)
  }

  return (
    <MaterialTextField
      required={isRequired}
      id={`${key}_${id}_text_field`}
      label={label}
      value={initialValue}
      onChange={setCurrentValueHandler}
      multiline
    />
  )
}

export default TextArea
